@if (betaCheck) {
  @if (showChatList || activeRooms.length) {
    <div class="absolute fixed-mobile top-mobile-0 left-mobile-0 right-mobile-0 bottom-0 right-xl mb-s am-flex-column height-760 height-mobile-auto width-400 width-mobile-full bg-white b-disabled b-radius-wide-xxs shadow-l overflow z-2" [class.display-none-i]="!showChatList">
      <div class="am-flex-align am-flex-shrink-0 gap-xxs bb-grey height-45 pl-s pr-xxs">
        <span class="font-l font-500 mra">Chats</span>
        <span class="am-flex-align gap-xxs b-grey pl-xs pr-xs pt-xxs pb-xxs hover-active-blue" (click)="openBulkList()">
          <span class="am-flex-center icon-chat-send font-xl"></span>
          <span class="font-s font-500">Gruppen-Chat</span>
        </span>
        <span class="am-flex-center icon-minus font-xl p-xs hover-active" title="Chat minimieren" (click)="minimize()"></span>
      </div>

      <chat-tabs [rooms]="tabs" [bulkMode]="bulkMode" [selected]="selectedTab" (selectTab)="selectTab($event)" (closeBulk)="closeBulk()"></chat-tabs>

      @for (room of tabs; track room.id) { <chat-box #room [chatFullAccess]="chatFullAccess" [room]="room" [class.display-none-i]="room.id !== selectedTab"></chat-box> }
      @if (bulkMode    ) { <bulk-messages [class.display-none-i]="selectedTab !== 'bulk'" (close)="closeBulk()"></bulk-messages> }
      @if (showChatList) { <chats-list    [class.display-none-i]="selectedTab" (openRoom)="openRoom($event)" (close)="toggleChatList(null)"></chats-list> }
    </div>
  }

  @if (!showChatList) { <chat-badge class="absolute bottom-0 right-0 mb-m mr-m z-2" (openChatList)="toggleChatList(true)"></chat-badge> }

  @if (showChatList) { <div class="mobile-show fixed-full bg-overlay z-1"></div> }
}
